import React from 'react'
import { useClientTypeDelMutation } from '../../store/ReactWebSiteApi';
import { Modal, App } from 'antd';

function ClientTypeDel(props) {
    const { message } = App.useApp();
    const {confirm} = Modal; 
    const [submitDel] = useClientTypeDelMutation()
    return (
        <>
            {props.ect_state==='2' && <a onClick={() => {
                            confirm({
                                title: '确定删除吗？',
                                content: props.ect_name,
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({
                                        ect_id:props.ect_id,
                                        ect_state:'2'
                                    }).then((res) => {
                                        if (res.data.Status === 'success') {
                                            message.info('删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                // console.log('Cancel');
                                },
                            });
                        }}>删除</a>}
            {props.ect_state==='1'&&<a onClick={() => {
                            confirm({
                                title: '确定取消删除吗？',
                                content: props.ect_name,
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({
                                        ect_id:props.ect_id,
                                        ect_state:'1'
                                    }).then((res) => {
                                        if (res.data.Status === 'success') {
                                            message.info('取消删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('取消删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                // console.log('Cancel');
                                },
                            });
                        }}>取消删除</a>}
        </>
    )
}

export default ClientTypeDel